import { getGlobalContent, getFrontPage } from '@lib/sanity.queries'

import type { GetStaticPropsContext } from 'next'
import TRANSLATIONS from '@locales/index'

import Page from '@components/ui/Page'

export async function getStaticProps({
  preview,
  locale = 'de',
  locales,
}: GetStaticPropsContext) {
  const page = await getFrontPage({ lang: locale }, preview)
  const global = await getGlobalContent({ lang: locale }, preview)

  return {
    props: {
      page,
      global,
      messages: TRANSLATIONS[locale],
      showPromo: true,
    },
    revalidate: 60,
  }
}

export default Page
